import { Box, Grid, Button, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import React from 'react'
import { Link } from 'react-router-dom'
import CheckIcon from '@material-ui/icons/CheckCircleOutline'
import ManFillingForm from './images/ManFillingForm'

const useStyles = makeStyles(theme => ({
  questionTitle: {
    textAlign: 'center',
    [theme.breakpoints.up('md')]: {
      textAlign: 'right',
    },
  },
  questionAnswer: {
    justifyContent: 'center',
    [theme.breakpoints.up('md')]: {
      justifyContent: 'flex-start',
    },
  },
}))

const LocationSupported = ({ placeId }) => {
  const classes = useStyles()

  return (
    <Box textAlign="center" padding="15px">
      <Typography variant="h4">Your location is supported by Foodsby!</Typography>
      <ManFillingForm width="300px" height="300px" />
      <Typography variant="subtitle2">
        Let&apos;s get you setup. Tell us a bit more about your office property.
      </Typography>
      <Box marginY={3}>
        <Grid container>
          <Grid item xs={12} md={6}>
            <Box className={classes.questionTitle} pr={3} mt={1}>
              <Typography color="textSecondary" variant="overline">
                Things we&apos;ll ask for:
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box className={classes.questionAnswer} display="flex" flexDirection="row" mt={2}>
              <Box mr={2}>
                <CheckIcon color="action" />
              </Box>
              <Typography color="textSecondary">Contact Information</Typography>
            </Box>
            <Box className={classes.questionAnswer} display="flex" flexDirection="row" mt={2}>
              <Box mr={2}>
                <CheckIcon color="action" />
              </Box>
              <Typography color="textSecondary">Property Details</Typography>
            </Box>
            <Box className={classes.questionAnswer} display="flex" flexDirection="row" mt={2}>
              <Box mr={2}>
                <CheckIcon color="action" />
              </Box>
              <Typography color="textSecondary">Foodsby Kiosk/Branding Selection</Typography>
            </Box>
            <Box
              className={classes.questionAnswer}
              display="flex"
              flexDirection="row"
              mt={2}
              mb={2}
            >
              <Box mr={2}>
                <CheckIcon color="action" />
              </Box>
              <Typography color="textSecondary">Delivery Driver & Pickup Instructions</Typography>
            </Box>
          </Grid>
        </Grid>
      </Box>

      <Box mt={3}>
        <Button
          component={Link}
          to={`/form/location-signup?placeid=${placeId}`}
          variant="contained"
          color="primary"
        >
          Get Started
        </Button>
      </Box>
    </Box>
  )
}

export default LocationSupported
